/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { FinancingStateInput } from '../../actions/get-financing-static-data';
import { IFinancingStaticDataData } from './financing-static-data.data';
import { IFinancingStaticDataProps } from './financing-static-data.props.autogenerated';

export interface IFinancingStaticDataViewProps extends IFinancingStaticDataProps<IFinancingStaticDataData> {}

/**
 *
 * FinancingStaticData component
 * @extends {React.PureComponent<IFinancingStaticDataProps<IFinancingStaticDataData>>}
 */
class FinancingStaticData extends React.PureComponent<IFinancingStaticDataProps<IFinancingStaticDataData>> {
    constructor(props: IFinancingStaticDataProps<IFinancingStaticDataData>) {
        super(props);
        this.setStaticFinancing.bind(this);
    }
    public componentDidMount(): void {
        this.setStaticFinancing();
    }
    public render(): JSX.Element | null {
        return null;
    }
    private setStaticFinancing = (): void => {
        this.props.context.actionContext.update(new FinancingStateInput(), { financingStaticData: this.props.config });
    };
}

export default FinancingStaticData;
